import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Avatar, Button, Typography, FormControl, FormGroup, CssBaseline, TextField, Paper, Box, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as authActions from "../../actions/user";
import useForm from '../core/useForm';
import Copyright from '../core/Copyright';
import Address from '../core/Address';
import ContactForm from './ContactForm';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
    },
    image: {
        backgroundImage: 'url(https://source.unsplash.com/random)',
        backgroundRepeat: 'no-repeat',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: '#f44336!important',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        marginTop: '10px !important'
    },
}));

const SignIn = (props) => {
    const classes = useStyles();
    const validate = (fieldValues = values) => {
        let temp = {};
        if ('username' in fieldValues) {
            temp.username = fieldValues.username ? "" : "This field is required";
        }
        if ('password' in fieldValues) {
            temp.password = fieldValues.password ? "" : "This field is required";
        }
        setErrors({
            ...temp
        });

        if (fieldValues == values) {
            return Object.values(temp).every(x => x == "");
        }
    }
    const {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange } = useForm({ username: '', password: '' }, validate);

    const login = (input) => {
        props.login(input.username, input.password).then(response => {
            window.location = '/';
        }).catch(error => { console.log(error) });
    }

    return (
        <Grid container spacing={3} component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={9} style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                backgroundSize: '150px 160px',
                backgroundColor: '#5DADE2'
            }} >
                <ContactForm />
            </Grid>
            <Grid item xs={3} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Sign in
                    </Typography>
                    <form className={classes.form} noValidate>
                        <FormGroup>
                            <FormControl>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    id="username"
                                    label="Username"
                                    name="username"
                                    autoComplete="username"
                                    autoFocus
                                    value={values.username}
                                    onChange={handleInputChange}
                                    {...(errors.username && { error: true, helperText: errors.username })}
                                />
                            </FormControl>
                            <FormControl>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Password"
                                    type="password"
                                    id="password"
                                    autoComplete="current-password"
                                    value={values.password}
                                    onChange={handleInputChange}
                                    {...(errors.password && { error: true, helperText: errors.password })}
                                />
                            </FormControl>
                        </FormGroup>
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            onClick={() => {
                                if (validate()) { login(values) }
                            }}
                        >Sign In</Button>
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            color="success"
                            className={classes.submit}
                            onClick={() => {
                                login({ username: "Guest", password: "guest" })
                            }}
                        >Sign in as Guest</Button>
                        <Box mt={5}>
                            <Copyright />
                            <Address />
                        </Box>
                    </form>
                </div>
            </Grid>
        </Grid>
    );
}

const mapStateToProps = state => ({
    isLoading: state.loading > 0
})

const mapActionToProps = {
    login: authActions.authenticate
}

export default withRouter(connect(mapStateToProps, mapActionToProps)(SignIn));